<script lang="ts">
    import {Route,router,active} from 'tinro'; 
	import Crumbs from "./Crumbs.svelte" 
	import ActorList from "./ActorList.svelte" 
	import GroupList from "./GroupList.svelte" 
	import NamedRightsList from "./NamedRightsList.svelte" 
	import RoleList from "./RoleList.svelte" 
	import StreamerList from "./StreamerList.svelte" 
	import NatsRTCClient from "./viewport/NatsRTCClient.svelte"

	import type { ActorGroup, RoleGroup, StreamerGroup, GroupSchema, Role, Actor, Streamer } from './jmdb'
	import { actor_groups, streamer_groups, role_groups, actor_list, role_list, streamer_list } from './jmdb'
	import { AuthPromise } from './auth';

	import { ButtonSet, Button, Tile } from "carbon-components-svelte";
	import Logout16 from "carbon-icons-svelte/lib/Logout16";
	import View24 from "carbon-icons-svelte/lib/View24";
	import Person16 from "carbon-icons-svelte/lib/Person16";
	import Tablet16 from "carbon-icons-svelte/lib/Tablet16";
	import GroupAccount16 from "carbon-icons-svelte/lib/GroupAccount16";
	import CertificateCheck16 from "carbon-icons-svelte/lib/CertificateCheck16";
	import UserRole16 from "carbon-icons-svelte/lib/UserRole16";
	import GroupAccess16 from "carbon-icons-svelte/lib/GroupAccess16";
	import GroupResource16 from "carbon-icons-svelte/lib/GroupResource16";



	let actor_group_schema: GroupSchema<ActorGroup, Actor> = {
		name: "Actor groups",
		resource_path: "actor_groups",
		element_store: actor_list,
		group_store: actor_groups,
		group_key: "actors",
		rel_path: "groups/actors"
	}

	let role_group_schema: GroupSchema<RoleGroup, Role> = {
		name: "Role groups",
		resource_path: "role_groups",
		element_store: role_list,
		group_store: role_groups,
		group_key: "roles",
		rel_path: "groups/roles"
	}

	let streamer_group_schema: GroupSchema<StreamerGroup, Streamer> = {
		name: "Streamer groups",
		resource_path: "streamer_groups",
		element_store: streamer_list,
		group_store: streamer_groups,
		group_key: "streamers",
		rel_path: "groups/streamers"
	}

	let authorized = true



	const isMobile = {
		Android: function() {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function() {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function() {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera: function() {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function() {
			return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
		},
		any: function() {
			return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
		}
	};

	const isFirefox = () => {
		return navigator.userAgent.match(/Firefox/i)
	}

	const isBrowserSupported = () => {
		return !(isMobile.any() || isFirefox())
	}

	AuthPromise.catch((e) => {
		if (isBrowserSupported()) {
			authorized = false
			window.location.href = "/oidc?next="+window.location.pathname
		}
	})
	
	let strix_version = "3.8.6"
	if (strix_version) {
		if (strix_version.startsWith("STRIX_VERSION")) {
			strix_version = "release candidate"
		}
	} else {
		strix_version = "v" + strix_version
	}


	//router.mode.hash()
</script>


<div class="container-xxl">
{#if !isBrowserSupported()}
	<p style="padding: 15vh 15%;">Only Chrome-based desktop browsers are currently supported.</p>
{:else if !authorized}
	<a href="/oidc?next={window.location.pathname}" tinro-ignore>Log in...</a>
{:else}

<Route path="/*">
	<Route path="/mon/*" breadcrumb="Monitor">
		<NatsRTCClient role="v"/>
	</Route>
	<Route path="/mgr/*" breadcrumb="Admin">
	<Route path="/">
		<Crumbs/>

		<ButtonSet stacked>
			<Button kind="primary" href="/mon/" icon={View24}>Monitor</Button>
			<Button kind="secondary" href="/mgr/actors" icon={Person16}>Actors</Button>
			<Button kind="secondary" href="/mgr/streamers" icon={Tablet16}>Streamers</Button>
			<Button kind="secondary" href="/mgr/groups" icon={GroupAccount16}>Groups</Button>
			<Button kind="secondary" href="/mgr/rights" icon={CertificateCheck16}>Rights</Button>
			<Button kind="secondary" href="/mgr/roles" icon={UserRole16}>Roles</Button>
			<Button icon={Logout16} kind="secondary" href="/logout" tinro-ignore>Log out</Button>
		</ButtonSet>

		<ButtonSet style="margin-top: var(--cds-spacing-04);" stacked>
			<Button kind="tertiary" disabled>Strix Elite<br/>{strix_version}</Button>
		</ButtonSet>
			
		
	</Route>
	<Route path="/actors/*" breadcrumb="Actors">
		<Route path="/" let:meta>
			<Crumbs/>
			<ActorList/>
		</Route>
		<Route path="/:id" let:meta>
			<Crumbs/>
			<ActorList actor_id={meta.params.id}/>
		</Route>
	</Route>
	<Route path="/groups/*" breadcrumb="Groups">
		<Route path="/" let:meta>
			<Crumbs/>
			<ButtonSet stacked>
				<Button kind="secondary" href="/mgr/groups/actors" icon={GroupAccess16}>Actor groups</Button>
				<Button kind="secondary" href="/mgr/groups/roles" icon={UserRole16}>Role groups</Button>
				<Button kind="secondary" href="/mgr/groups/streamers" icon={GroupResource16}>Streamer groups</Button>
			</ButtonSet>
		</Route>
		<Route path="/actors/*" breadcrumb="Actor groups">
			<Route path="/">
				<Crumbs/>
				<GroupList schema={actor_group_schema} />
			</Route>
			<Route path="/:id" let:meta>
				<Crumbs/>
				<GroupList schema={actor_group_schema} group_id={meta.params.id}/>
			</Route>
		</Route>
		<Route path="/roles/*" breadcrumb="Role groups">
			<Route path="/">
				<Crumbs/>
				<GroupList schema={role_group_schema}/>
			</Route>
			<Route path="/:id" let:meta>
				<Crumbs/>
				<GroupList schema={role_group_schema} group_id={meta.params.id}/>
			</Route>
		</Route>
		<Route path="/streamers/*" breadcrumb="Streamer groups">
			<Route path="/">
				<Crumbs/>
				<GroupList schema={streamer_group_schema}/>
			</Route>
			<Route path="/:id" let:meta>
				<Crumbs/>
				<GroupList schema={streamer_group_schema} group_id={meta.params.id}/>
			</Route>
		</Route>
	</Route>
	<Route path="/rights/*" breadcrumb="Rights">
		<Route path="/">
			<Crumbs/>
			<NamedRightsList/>
		</Route>
		<Route path="/:id" let:meta>
			<Crumbs/>
			<NamedRightsList right_id={meta.params.id}/>
		</Route>
	</Route>
	<Route path="/roles/*" breadcrumb="Roles">
		<Route path="/">
			<Crumbs/>
			<RoleList/>
		</Route>
		<Route path="/:id" let:meta>
			<Crumbs/>
			<RoleList role_id={meta.params.id}/>
		</Route>
	</Route>
	<Route path="/streamers/*" breadcrumb="Streamers">
		<Crumbs/>
		<Route path="/">
			<StreamerList/>
		</Route>
		<Route path="/:id" let:meta>
			<StreamerList streamer_id={meta.params.id}/>
		</Route>
	</Route>
	</Route>
</Route>

{/if}
</div>